import React, { useEffect, useState } from "react";
import "./Avis.css";

export default function Avis() {
    const [reviews, setReviews] = useState([]);

    // URL directe vers le backend PHP en ligne
    const API_URL = "https://amservices.eu/api/avis.php";

    useEffect(() => {
        fetch(API_URL)
            .then(res => res.json())
            .then(data => setReviews(data))
            .catch(err => console.error(err));
    }, []);

    const sliderReviews = [...reviews, ...reviews];

    return (
        <div className="avis">
            <h2>Nos avis</h2>
            <div className="avis-slider-container">
                <div className="avis-slider">
                    {sliderReviews.map((review, index) => (
                        <div key={index} className="avis-slide-card">
                            <div className="avis-author">
                                <img src={review.profile_photo_url} alt={review.author_name} />
                                <span>{review.author_name}</span>
                            </div>
                            <div className="avis-rating">{"⭐".repeat(review.rating)}</div>
                            <div className="avis-text"> <p>{review.text}</p></div>
                        </div>
                    ))}
                </div>
            </div></div>
    );
}
